import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { info, loading } from '@/js/lib/ui';
import { resetPassword, type ResetPasswordData } from '@/js/lib/api/signin/resetPassword';
import FormWrapHasTitle from '@/js/components/organisms/FormWrapHasTitle.vue';
import FormSection from '@/js/components/organisms/FormSection.vue';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgetPasswordForm',
  setup(__props) {

const observer = ref();
const formData = ref<ResetPasswordData>({
  email: '',
});
const isShowDialog = ref(false);
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    return;
  }

  loading({
    asyncFunc: async () => {
      try {
        await resetPassword(formData.value);
        isShowDialog.value = true;
      } catch (error) {
        info(error.response.data.message);
      }
    },
  });
};

return { __sfc: true,observer, formData, isShowDialog, onSubmit, FormWrapHasTitle, FormSection, IButton, ITextField, IModal }
}

})